import axios, { AxiosRequestConfig, AxiosResponse, Method } from 'axios';
import { apiExpress, options } from 'lib/config';
import { useQueryState } from './useQueryState';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';

export interface ExpandedAxiosResponse extends AxiosResponse<any> {
  success?: boolean;
}

export type UseQueryProps = {
  method?: Method;
  params?: {};
  pathname?: string;
  autoFetch?: boolean;
  showToastMessage?: boolean;
};

export const useQueryFetch = ({
  method,
  pathname,
  params,
  autoFetch = false,
  showToastMessage = true,
}: UseQueryProps) => {
  const { state, dispatch } = useQueryState({
    data: null,
    error: '',
    loading: false,
  });

  const { data, error, loading, progress } = state;
  const fetchData = async (requestConfig?: AxiosRequestConfig, id?: any) => {
    dispatch({ type: 'REQUEST' });
    const progressInterval = setInterval(() => {
      dispatch({ type: 'PROGRESS' });
    }, 200);

    let baseUrl = requestConfig?.baseURL;

    if (!baseUrl) {
      baseUrl = apiExpress;
    }

    const headers = options.bearerToken;

    // @ts-ignore
    let config: AxiosRequestConfig = {
      url: pathname,
      baseURL: baseUrl,
      method: typeof method !== 'undefined' ? method : 'get',
      params: params,
    };
    axios({ ...config, ...{ headers }, ...requestConfig })
      .then((response: ExpandedAxiosResponse) => {
        let { data, success } = response;
        if (data && data.message && showToastMessage) {
          successToast({ title: data.message });
        }
        if (data.id) {
          data.video_id = data.id;
        }
        if (method === 'patch') {
          if (Array.isArray(data)) {
            data = data.length > 0 ? 'SUCCESS' : success;
          }
          data = data === true ? 'SUCCESS' : 'ERROR';
        }
        if (id >= 0) {
          data.id = id;
          if (data.data) {
            data.data.id = id;
          }
        }
        dispatch({ type: 'SUCCESS', data });
        clearInterval(progressInterval);
      })
      .catch(error => {
        dispatch({ type: 'FAILURE', error: error.message });
        if (showToastMessage) errorToast({ title: error.message });
        clearInterval(progressInterval);
      });
  };
  if (autoFetch && data == null && loading === false && !error) {
    fetchData();
  }
  return {
    data,
    loading,
    error,
    fetchData,
    progress,
  };
};
